// Static client-app identifier the backend boilerplate expects on every request
// (see backend CLIENT_ID / UserApiTokens) — not a per-user secret, safe to ship in the bundle.
export const INITIAL_TOKEN = "6e303344-9a15-467b-b494-3dcc61f0c373";
export const BASE_URL = process.env.REACT_APP_API_URL || "https://api.meraxes.org";
